/* eslint-disable */
import React from 'react';
import Container from './Container';
import Logo from '../icons/logo-offwhite.svg';
import UpArrow from '../icons/up-arrow.svg';
import DownArrow from '../icons/down-arrow.svg';
import style from '../cssmodules/shareprice.module.scss';

function SharePrice({ data }) {
  return (
    <div className={style.shareprice}>
      <Container>
        <div className={style.wrapper}>
          <div className={style.column}>
            <h2 className="heading4">
              Opyl is headquartered in Melbourne, Australia and listed on the
              Australian Stock Exchange (ASX:OPL)
            </h2>
          </div>
          <div className={style.column}>
            <div className={style.investorCenter}>
              <div className={style.investorCenterLogo}>
                <Logo />
              </div>
              <h3 className={style.investorCenterHeading}>
                Investor
                <br />
                Center
              </h3>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default SharePrice;
